// client/src/api/shippingApi.js
import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api/shipping";

export const getRates = async (shipmentData) => {
  // shipmentData = { fromAddress: {…}, toAddress: {…}, parcels: [ { … } ] }
  const resp = await axios.post(`${API_BASE}/rates`, shipmentData);

  return resp.data.rates;
};

export const createLabel = async (rateObjectId) => {
  const resp = await axios.post(`${API_BASE}/label`, { rateObjectId });

  return resp.data; // { labelUrl, trackingNumber }
};
